import TabTemplate from "components/shared/profile/tab";
import { organizationFlags, organizationFlagsEnum } from "helpers/enums";
import { flagVal, paramsObject } from "helpers/system";
import policy from "policies";
import React from "react";
import { delAccount, editNotificationOptions, updateInformation } from "sources/profile/user";
import { del as logoff } from "sources/session";
import NotificationSettings from "./notificationSettings";
import OrderNotifications from "./orderNotifications";
import Password from "./password";
import PersonalInfo from "./personalInfo";
import PowerOfAttorneys from "./powerOfAttorneys";

const suitableOrdersFlagVal = flagVal(organizationFlags, organizationFlagsEnum.SuitableOrders);

export default class OwnProfileTab extends TabTemplate {
    componentDidMount() {
        this.props.getUser().then(() => {
            this.setState({ isLoading: false });
            const { tab } = paramsObject(this.props.location.search);
            if (tab) {
                setTimeout(() => {
                    document.getElementById(tab)?.scrollIntoView();
                }, 0);
            }
        });
    }

    delUser = () => {
        const { modal, profile } = this.props;
        const action = () => delAccount({ userId: profile.id }).then((res) => (res ? logoff() : null));
        return modal({
            name: "confirm",
            title: "Удаление аккаунта",
            text: "Вы уверены, что хотите удалить аккаунт? Это действие необратимо",
            action,
        });
    };

    renderBody = () => {
        const { editable, getUser, profile, getNotificationOptions, notificationOptions, roles, modal, organization } =
            this.props;
        const suitableOrdersEnabled = (organization.intFlags & suitableOrdersFlagVal) === suitableOrdersFlagVal;
        return (
            <div>
                <PersonalInfo
                    action={updateInformation}
                    data={profile}
                    update={getUser}
                    editable={editable}
                    modal={modal}
                    roles={roles}
                />
                <PowerOfAttorneys
                    editable={editable}
                    modal={modal}
                    powerOfAttorneys={profile.powerOfAttorneys}
                    update={getUser}
                />
                {suitableOrdersEnabled && <OrderNotifications editable={editable} />}
                {policy("user", { user: { roles } }).isTruckingOrg() && (
                    <NotificationSettings
                        action={editNotificationOptions}
                        data={notificationOptions}
                        update={getNotificationOptions}
                    />
                )}
                <Password editable />
                <div className="profile-body__rows-group">
                    {/* <PhoneNumber data={profile} update={getUser} editable={editable} />
                    <div className="panel panel--small">
                        <div className="panel__text panel__text--with-paddings">
                            Вы можете удалить аккаунт, но помните, что это действие необратимо.
                        </div>
                        <div className="panel__button-group">
                            <div className="panel__button panel__button--red panel__button--margins" onClick={this.delUser}>
                                Удалить Аккаунт
                            </div>
                        </div>
                    </div> */}
                </div>
            </div>
        );
    };
}
